import { render, staticRenderFns } from "./OfferDetailsBlock.vue?vue&type=template&id=49aad644&scoped=true"
import script from "./OfferDetailsBlock.vue?vue&type=script&lang=js"
export * from "./OfferDetailsBlock.vue?vue&type=script&lang=js"
import style0 from "./OfferDetailsBlock.vue?vue&type=style&index=0&id=49aad644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aad644",
  null
  
)

export default component.exports